/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserMessageSeverity } from './UserMessageSeverity';
import {
    UserMessageSeverityFromJSON,
    UserMessageSeverityFromJSONTyped,
    UserMessageSeverityToJSON,
    UserMessageSeverityToJSONTyped,
} from './UserMessageSeverity';
import type { ActiveDirectoryAction } from './ActiveDirectoryAction';
import {
    ActiveDirectoryActionFromJSON,
    ActiveDirectoryActionFromJSONTyped,
    ActiveDirectoryActionToJSON,
    ActiveDirectoryActionToJSONTyped,
} from './ActiveDirectoryAction';

/**
 * 
 * @export
 * @interface ValidateLocalAccountResponse
 */
export interface ValidateLocalAccountResponse {
    /**
     * 
     * @type {string}
     * @memberof ValidateLocalAccountResponse
     */
    version: string;
    /**
     * 
     * @type {ActiveDirectoryAction}
     * @memberof ValidateLocalAccountResponse
     */
    action: ActiveDirectoryAction;
    /**
     * 
     * @type {string}
     * @memberof ValidateLocalAccountResponse
     */
    userMessage?: string | null;
    /**
     * 
     * @type {UserMessageSeverity}
     * @memberof ValidateLocalAccountResponse
     */
    messageSeverity?: UserMessageSeverity;
    /**
     * 
     * @type {number}
     * @memberof ValidateLocalAccountResponse
     */
    status?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ValidateLocalAccountResponse
     */
    statusCode: number;
    /**
     * 
     * @type {boolean}
     * @memberof ValidateLocalAccountResponse
     */
    isAccountRegistered: boolean;
}



/**
 * Check if a given object implements the ValidateLocalAccountResponse interface.
 */
export function instanceOfValidateLocalAccountResponse(value: object): value is ValidateLocalAccountResponse {
    if (!('version' in value) || value['version'] === undefined) return false;
    if (!('action' in value) || value['action'] === undefined) return false;
    if (!('statusCode' in value) || value['statusCode'] === undefined) return false;
    if (!('isAccountRegistered' in value) || value['isAccountRegistered'] === undefined) return false;
    return true;
}

export function ValidateLocalAccountResponseFromJSON(json: any): ValidateLocalAccountResponse {
    return ValidateLocalAccountResponseFromJSONTyped(json, false);
}

export function ValidateLocalAccountResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidateLocalAccountResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'version': json['version'],
        'action': ActiveDirectoryActionFromJSON(json['action']),
        'userMessage': json['userMessage'] == null ? undefined : json['userMessage'],
        'messageSeverity': json['messageSeverity'] == null ? undefined : UserMessageSeverityFromJSON(json['messageSeverity']),
        'status': json['status'] == null ? undefined : json['status'],
        'statusCode': json['statusCode'],
        'isAccountRegistered': json['isAccountRegistered'],
    };
}

export function ValidateLocalAccountResponseToJSON(json: any): ValidateLocalAccountResponse {
    return ValidateLocalAccountResponseToJSONTyped(json, false);
}

export function ValidateLocalAccountResponseToJSONTyped(value?: ValidateLocalAccountResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'version': value['version'],
        'action': ActiveDirectoryActionToJSON(value['action']),
        'userMessage': value['userMessage'],
        'messageSeverity': UserMessageSeverityToJSON(value['messageSeverity']),
        'status': value['status'],
        'statusCode': value['statusCode'],
        'isAccountRegistered': value['isAccountRegistered'],
    };
}

